import BusinessReturnMobileList from '@/components/BusinessReturnMobile/BusinessReturnMobileList'
import BusinessReturnMobileDetail from '@/components/BusinessReturnMobile/BusinessReturnMobileDetail'
import BusinessReturnMobileForm from '@/components/BusinessReturnMobile/BusinessReturnMobileForm'

let BusinessReturnMobileRouter = [{
    path: '/business_return_mobile',
    name: 'BusinessReturnMobileList',
    component: BusinessReturnMobileList,
    meta: {
      title: 'Retours',
      requiresAuth: true,
      authorizations: ['business-return_index', 'mobile_access']
    }
  },
  {
    path: '/business_return_mobile/:id',
    name: 'BusinessReturnMobileDetail',
    component: BusinessReturnMobileDetail,
    meta: {
      title: 'Fiche retour',
      requiresAuth: true,
      authorizations: ['business-return_show', 'mobile_access']
    }
  },
  {
    path: '/business_return_mobile/new/:id',
    name: 'BusinessReturnMobileNew',
    component: BusinessReturnMobileForm,
    meta: {
      title: 'Nouveau retour',
      requiresAuth: true,
      authorizations: ['business_return_new', 'mobile_access']
    }
  }
]

export default BusinessReturnMobileRouter



// WEBPACK FOOTER //
// ./src/components/BusinessReturnMobile/router.js